import { useState, useCallback } from 'react';

interface Message {
  id: string;
  type: 'success' | 'error';
  message: string;
}

export const useMessages = () => {
  const [messages, setMessages] = useState<Message[]>([]);

  const addMessage = useCallback((type: 'success' | 'error', message: string) => {
    const id = Date.now().toString() + Math.random().toString(36).substr(2, 9);
    const newMessage: Message = { id, type, message };
    
    setMessages(prev => [...prev, newMessage]);
    
    // Auto-remove after timeout
    const timeout = type === 'success' ? 3000 : 5000;
    setTimeout(() => {
      setMessages(prev => prev.filter(msg => msg.id !== id));
    }, timeout);
  }, []);

  const removeMessage = useCallback((id: string) => {
    setMessages(prev => prev.filter(msg => msg.id !== id));
  }, []);

  const showSuccess = useCallback((message: string) => {
    addMessage('success', message);
  }, [addMessage]);

  const showError = useCallback((message: string) => {
    addMessage('error', message);
  }, [addMessage]);

  const clearMessages = useCallback(() => {
    setMessages([]);
  }, []);

  return {
    messages,
    showSuccess,
    showError,
    removeMessage,
    clearMessages
  };
}; 